import { useGetAlbumVideo } from '@vimeo/gctl-api/hooks/useAlbumVideo';
import { useViewer } from '@vimeo/viewer';

import { useAlbumStore } from '../state/albumStore';

export function useDownloadVideoFiles(videoId: string | null) {
  const { albumId, albumSignature, password, isShowcaseEmbedded, referer } = useAlbumStore(
    (state) => ({
      albumId: state.albumId,
      albumSignature: state.albumSignature,
      password: state.hashedPass,
      isShowcaseEmbedded: state.isShowcaseEmbedded,
      referer: state.referrer,
    }),
  );

  const viewer = useViewer();

  const { data, isLoading } = useGetAlbumVideo(
    () => {
      if (!viewer || !videoId || albumSignature === null) return null;

      return {
        where: { albumId, videoId: Number(videoId) },
        select: [
          'download.height',
          'download.link', // // This fields need albumSignature
          'download.publicName',
          'download.quality',
          'download.sizeShort',
          'download.type',
          'download.width',
          'download.videoFileId',
          'download.size',
        ],
        query: {
          isEmbed: isShowcaseEmbedded,
          referrer: referer,
          ...(password && { password }),
          ...(albumSignature && { albumSignature, albumUri: `albums/${albumId}` }),
        },
      };
    },
    {
      revalidateOnFocus: false,
    },
  );

  const download = data?.download ?? [];
  const videoFiles = download.sort((fileA, fileB) =>
    fileA.quality === 'source' ? 0 : fileB.height - fileA.height,
  );
  return { videoFiles, isLoading };
}
